import { Effect, Stream, SubscriptionRef } from 'effect';

import { RuntimeClientAtom } from '../../runtime/RuntimeClient';
import { SupportBox } from '../../service/supportBox/SupportBox';
import * as Atom from 'effect/unstable/reactivity/Atom';
import * as AsyncResult from 'effect/unstable/reactivity/AsyncResult';

const supportBoxStateRefAtom = RuntimeClientAtom.atom(
  Effect.gen(function* () {
    const supportBox = yield* SupportBox;

    return supportBox.stateRef;
  })
).pipe(Atom.keepAlive, Atom.withServerValueInitial);

const supportBoxIsOnlineStreamAtom = RuntimeClientAtom.atom((get) => {
  const stateRefResult = get(supportBoxStateRefAtom);

  return AsyncResult.match(stateRefResult, {
    onInitial: () => Stream.make(false),
    onFailure: () => Stream.make(false),
    onSuccess: (success) =>
      SubscriptionRef.changes(success.value).pipe(Stream.map((state) => state.isOnline)),
  });
}).pipe(Atom.keepAlive);

export const supportBoxIsOnlineAtom = Atom.make((get) => {
  const streamResult = get(supportBoxIsOnlineStreamAtom);

  return AsyncResult.match(streamResult, {
    onInitial: () => false,
    onFailure: () => false,
    onSuccess: (result) => result.value,
  });
});

export const openSupportBoxFn = RuntimeClientAtom.fn(
  Effect.fn(function* () {
    const supportBox = yield* SupportBox;
    return yield* supportBox.open;
  })
);
